import asMyList from '../../components/asMyList.js';
import ABSWineAgenciesCatalogue from './ABSWineAgenciesCatalogue';
import ABSTableSigns from './ABSTableSigns';

// This follows the naming conventions from Classic
export const templates = {
  'abs.wine/TableSigns': asMyList(ABSTableSigns),
  'abs.wine/Catalogue': asMyList(ABSWineAgenciesCatalogue),
};
